import(/* webpackMode: "eager" */ "/Users/alextotalwin/Next Robot AI — Вологда/src/app/page.tsx");
